export default __webpack_public_path__ + "static/media/discordIcon.ce79af33.svg";